import { HttpClient } from '../../httpClient'
import { OpalApiRequestParams } from '../../schema'

interface DeleteCategoryArguments {
  params: OpalApiRequestParams<'DeleteCategoryV3'>
}

export async function deleteCategory({
  params,
}: DeleteCategoryArguments): Promise<null> {
  const url = new URL(
    `/loupe/v3/categories/${params.path.category_id}`,
    window.location.origin
  )

  return HttpClient()
    .delete(url.toString())
    .then(() => null)
}
